import { Breakpoint } from "vuetify/types/services/breakpoint";

class URLParamService {
  private _isAppPlayer = process.env.VUE_APP_IS_APP_PLAYER === "true";

  urlParam(name: string): string | null {
    const results = new RegExp("[?&]" + name + "=([^&#]*)").exec(document.location.href);
    if (results == null) {
      return null;
    } else {
      return decodeURI(results[1]) || null;
    }
  }

  //Default value: true
  isAudioMuted(): boolean {
    // when played via app don't mute audio
    if (this._isAppPlayer || this.urlParam("mute-audio") === "false") {
      return false;
    } else {
      return true;
    }
  }

  //Default value: true
  useAutostart(): boolean {
    if (this.urlParam("autostart") === "false") {
      return false;
    } else {
      return true;
    }
  }

  mediaControlHideTimeout(breakpoint: Breakpoint): number {
    let factor = 1;
    const touchDevice = navigator.maxTouchPoints || "ontouchstart" in document.documentElement;

    switch (breakpoint.name) {
      case "xs":
      case "sm":
      case "md":
        if (touchDevice) {
          factor = 2;
        }
        break;
    }
    const timeout = this.urlParam("media-control-timeout") || 1500;
    return parseInt("" + timeout) * factor;
  }

  initialShowMediaControls(): boolean {
    if (this.urlParam("initial-show-media-controls") === "true") {
      return true;
    } else {
      return false;
    }
  }

  //Default value: false
  loopPlaylist(): boolean {
    // when played via app always loop playlist
    if (this._isAppPlayer || this.urlParam("loop-playlist") === "true" || this.urlParam("loop") === "true") {
      return true;
    } else {
      return false;
    }
  }
  /// should use cdn and contentconvert?
  /// default: true
  useCdn(): boolean {
    if (this.urlParam("cdn") === "false") {
      return false;
    }
    return true;
  }

  get isAppPlayer(): boolean {
    return this._isAppPlayer;
  }

  get layout() {
    return this.urlParam("layout") || "default";
  }

  get looseFocusKeys(): string[] {
    return (this.urlParam("looseFocusKeys") || this.urlParam("loose-focus-keys") || "ArrowUp").split(",");
  }

  get allowFullscreen(): boolean {
    // in app player fullscreen is handled by the app, so don't allow fullscreen in that case
    if (this._isAppPlayer || this.urlParam("allow-fullscreen") === "false") {
      return false;
    }
    return true;
  }

  get hideProgressBar(): boolean {
    // in app player progress bar is not required
    return this._isAppPlayer || this.urlParam("hide-progress-bar") === "true";
  }
}

export const urlParamService = new URLParamService();
